import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Container } from '../../components';
import Slider from './design-slider';
import styles from './design-wireframing.module.css';

export default function DesignWireframing() {
  return (
    <section className={styles.root}>
      <Container>
        <h2 className={styles.title} id="wireframing">
          Wireframing
        </h2>
        <div className={styles.row}>
          <p className={styles.text}>
            The sketches are ready, let&apos;s draw the lines more clearly and
            boldly!
            <br />
            <br />
            It&apos;s time for the UX details. We create black and white
            screens, forgetting about the colours for a while. At this stage, it
            is important to think through all the smallest details so that the
            user could use our project conveniently, easily and clearly. At the
            end of this stage, you have all the logic of the future app in your
            hands.
          </p>
          <div className={styles.box}>
            <span className={styles.counter}>02</span>
            <span className={styles.subtitle}>Sketching</span>
          </div>
        </div>
      </Container>
      <AnimationOnScroll
        delay={800}
        offset={50}
        animateOnce
        duration={1.2}
        animateIn="animate__fadeIn"
      >
        <Slider />
      </AnimationOnScroll>
    </section>
  );
}
